import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-xxl-12 mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "col-xxl-12 mt-5"
}
const _hoisted_3 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductGCBalances = _resolveComponent("ProductGCBalances")
  const _component_ProductGCProcess = _resolveComponent("ProductGCProcess")
  const _component_ProductGCHistory = _resolveComponent("ProductGCHistory")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ProductGCBalances, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
    ]),
    (!_ctx.isOverriden)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProductGCProcess, {
                key: 0,
                gcmodeldata: _ctx.gcmodeldata,
                "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8"
              }, null, 8, ["gcmodeldata"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProductGCHistory, {
            key: 0,
            "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}